import scottAvatar from "@/assets/scott-avatar.webp";

type Props = { onClick: () => void };

export function AskScottBubble({ onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Ask Scott, AI assistant"
      className="ask-scott-bubble group relative grid h-14 w-14 place-items-center rounded-full border-2 border-foreground bg-gradient-hero text-primary-foreground transition-transform hover:scale-105 active:scale-95 md:h-16 md:w-16"
    >
      <img
        src={scottAvatar}
        alt=""
        aria-hidden
        width={56}
        height={56}
        className="h-full w-full rounded-full object-cover"
      />
      <span
        aria-label="Online"
        className="absolute -top-0.5 -right-0.5 block h-4 w-4 rounded-full border-2 border-background bg-[oklch(0.72_0.2_145)] shadow-[0_0_8px_oklch(0.72_0.2_145/0.7)]"
      />
    </button>
  );
}
